import Modulos from "@/entities/Modulos";
import ModulosDetails from "@/entities/ModulosDetails";
import modulosData from "@/data/modulos.json";
import moduloDetailsData from "@/data/moduloDetails.json";

const modulos = modulosData as unknown as Modulos[];
const moduloDetails = moduloDetailsData as unknown as ModulosDetails[];

export default class ModulosService {
  public async getModulos(): Promise<Modulos[]> {
    return modulos;
  }

  public async getModuloById(id: number): Promise<Modulos> {
    return modulos.find((modulo) => modulo.id === id) as Modulos;
  }

  public async getDetalleModuloById(id: number): Promise<ModulosDetails[]> {
    return moduloDetails.filter((detalle) => detalle.modulo_id === id);
  }
}
